import { CircularProgress, Grid, IconButton } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Alert, Autocomplete } from "@material-ui/lab";
import { IconDeviceFloppy, IconEye, IconEyeOff } from "@tabler/icons-react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { useCreateUserMutation } from "../../../services/users/usersService";

const profileOptions = [
  { value: "1", label: "Administrador" },
  { value: "2", label: "Cliente" },
];

interface props {
  refetchList: () => void;
}

const AddUserForm = ({ refetchList }: props) => {
  const [showPass, setShowPass] = useState(false);
  const [keyAutocomplete, setKeyAutocomplete] = useState(1);

  const schema = yup.object().shape({
    nombre: yup.string().required("Nombre es requerido"),
    correo: yup
      .string()
      .email("Ingrese un correo válido")
      .required("Correo es requerido"),
    contrasenia: yup
      .string()
      .min(6, "Contraseña debe tener 6 caracteres mínimo")
      .required("Contrasña es requerida"),
    perfil: yup.string().required("Perfil es requerido"),
    cedula: yup
      .string()
      .matches(/^[0-9]*$/, "Cédula solo debe contener números")
      .min(10, "Cédula debe tener minimo 10 caracreres")
      .max(10, "Cédula debe tener máximo 10 caracteres"),
  });

  const [createUser, { isLoading, isSuccess, isError, reset, error }] =
    useCreateUserMutation();

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      nombre: "",
      correo: "",
      contrasenia: "",
      perfil: "",
      cedula: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      // return alert(JSON.stringify(values));
      createUser({
        contrasenia: values.contrasenia,
        email: values.correo,
        nombre: values.nombre,
        perfil: values.perfil,
        cedula: values.cedula,
      });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      setKeyAutocomplete(keyAutocomplete + 1);
      refetchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, resetForm]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Nombre"
          placeholder="Ingrese nombre"
          fullWidth
          variant="outlined"
          {...getFieldProps("nombre")}
          error={Boolean(errors.nombre && touched.nombre)}
          helperText={Boolean(errors.nombre && touched.nombre) && errors.nombre}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Correo"
          placeholder="Ingrese correo"
          fullWidth
          variant="outlined"
          {...getFieldProps("correo")}
          error={Boolean(errors.correo && touched.correo)}
          helperText={Boolean(errors.correo && touched.correo) && errors.correo}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Contraseña"
          type={showPass ? "text" : "password"}
          placeholder="Ingrese contraseña"
          fullWidth
          variant="outlined"
          {...getFieldProps("contrasenia")}
          error={Boolean(errors.contrasenia && touched.contrasenia)}
          helperText={
            Boolean(errors.contrasenia && touched.contrasenia) &&
            errors.contrasenia
          }
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => setShowPass(!showPass)}>
                {!showPass ? <IconEye /> : <IconEyeOff />}
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          key={keyAutocomplete}
          options={profileOptions}
          getOptionLabel={(option) => option.label}
          getOptionSelected={(option, value) => option.value === value.value}
          disableClearable
          onChange={(_, { value }) => setFieldValue("perfil", value)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Perfil"
              placeholder="Seleccione perfil"
              error={Boolean(errors.perfil && touched.perfil)}
              helperText={
                Boolean(errors.perfil && touched.perfil) && errors.perfil
              }
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          placeholder="Ingrese cédula"
          fullWidth
          variant="outlined"
          label="Cédula"
          {...getFieldProps("cedula")}
          error={Boolean(errors.cedula && touched.cedula)}
          helperText={Boolean(errors.cedula && touched.cedula) && errors.cedula}
        />
      </Grid>
      {isSuccess && (
        <Grid item xs={12}>
          <Alert severity="success" onClose={reset}>
            Usuario creado correctamente
          </Alert>
        </Grid>
      )}
      {isError && (
        <Grid item xs={12}>
          <Alert severity="error" onClose={reset}>
            {String(error)}
          </Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<IconDeviceFloppy />}
          onClick={() => handleSubmit()}
          disabled={isLoading}
          endIcon={isLoading && <CircularProgress size={10} />}
        >
          Guardar
        </Button>
      </Grid>
    </Grid>
  );
};

export default AddUserForm;
